import React, { lazy, Suspense } from 'react'
import { isMobile } from 'react-device-detect'
const DesktopOffer = lazy(() => import('./desktop/offer'))
const MobileOffer = lazy(() => import('./mobile/offer'))
type Props = {
    rank: number,
    text: string,
    link: string,
    site: string,
    query?: string,
    hasNoReview?: boolean,
    isReviewPage?: boolean,
}

function Offer(props: Props) {
    const query = props.query || ''
    return <>
        <Suspense fallback={<></>}>
            {(!isMobile || props.isReviewPage) && <DesktopOffer rank={props.rank} query={query} text={props.text} site={props.site} link={props.link} hasNoReview={props.hasNoReview} isReviewPage={props.isReviewPage} />}
            {isMobile && !props.isReviewPage && <MobileOffer rank={props.rank} query={query} text={props.text} site={props.site} link={props.link} hasNoReview={props.hasNoReview} />}
        </Suspense>
    </>
}

export default Offer